import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { borderRadius, breakpoints, spacing } from '@naf/theme';
import { themeLight } from '@lib/nafTheme';
import { Heading } from '../Styles';

export const ScrollContainer = styled.div`
  overflow-x: scroll;
  display: flex;
  scroll-snap-type: x mandatory;
  align-items: center;

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
`;

export const ScrollItem = styled.div<{ $isFirst?: boolean; $isLast?: boolean }>`
  scroll-snap-align: center;
  margin-left: ${({ $isFirst }) => ($isFirst ? spacing.space80 : spacing.space32)};
  margin-right: ${({ $isLast }) => ($isLast ? spacing.space80 : '0px')};
  min-width: calc(100% - 160px);

  @media (max-width: ${breakpoints.l}) {
    margin-left: ${({ $isFirst }) => ($isFirst ? spacing.space40 : spacing.space32)};
    margin-right: ${({ $isLast }) => ($isLast ? spacing.space40 : '0px')};
    min-width: calc(100% - 120px);
  }

  @media (max-width: ${breakpoints.s}) {
    margin-left: ${({ $isFirst }) => ($isFirst ? spacing.space24 : spacing.space16)};
    margin-right: ${({ $isLast }) => ($isLast ? spacing.space24 : '0px')};
    min-width: calc(100% - 56px);
  }
`;

export const QnATitle = styled(Text)`
  padding-left: ${spacing.space80};
  margin: 0;
  @media (max-width: ${breakpoints.l}) {
    padding-left: ${spacing.space40};
  }

  @media (max-width: ${breakpoints.s}) {
    padding-left: ${spacing.space24};
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: ${spacing.space32};
`;

export const Container = styled.div`
  border: 2px solid ${({ theme }) => (theme?.background ? theme.background.brand : themeLight.background.brand)};
  border-radius: ${borderRadius.M};
  display: flex;
  justify-content: center;
  @media (max-width: ${breakpoints.l}) {
    flex-direction: column;
  }

  @media (max-width: ${breakpoints.s}) {
    margin: 0;
    margin-left: -24px;
    width: calc(100vw - 4px);
  }
`;

export const InnerLeft = styled.div`
  padding: ${spacing.space24} ${spacing.space80} ${spacing.space40} ${spacing.space40};

  @media (max-width: ${breakpoints.l}) {
    max-width: 100%;
    padding: ${spacing.space24} ${spacing.space40};
  }

  @media (max-width: ${breakpoints.s}) {
    padding: ${spacing.space16} ${spacing.space24};
  }
`;

export const InnerRight = styled.div`
  padding: ${spacing.space40} 0;
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: ${breakpoints.l}) {
    max-width: 100%;
    padding: ${spacing.space24} 0;
  }

  @media (max-width: ${breakpoints.s}) {
    padding: ${spacing.space16} 0;
  }
`;

export const QnAItemWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Left = styled.div`
  background: ${({ theme }) => (themeLight?.background ? theme.background.brand : themeLight.background.brand)};
  width: 50%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: ${breakpoints.l}) {
    width: 100%;
  }
  z-index: 4;
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: ${spacing.space24};
`;

export const Right = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  @media (max-width: ${breakpoints.l}) {
    width: 100%;
    height: 100%;
    min-height: 600px;
  }
`;

export const ImageWrapper = styled.div`
  width: ${spacing.space120};
  height: ${spacing.space120};
  margin-bottom: ${spacing.space32};
  img {
    height: 100%;
    width: 100%;
  }
`;
